export default function WSPATRSection() {
  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            WSP & ATR Requirements
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Understanding the key components and requirements for successful WSP and ATR submissions
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* WSP Section */}
          <div className="card p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-[#2D7F3E] text-white rounded-lg flex items-center justify-center mr-4">
                <i className="ri-file-edit-line text-xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Workplace Skills Plan (WSP)</h3>
                <p className="text-gray-600">Due: April 30 annually</p>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Required Components:</h4>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Company profile and organisational structure</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Skills gap analysis and needs assessment</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Planned training interventions for the year</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Budget allocation for skills development</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Employment equity targets and plans</span>
                  </div>
                </div>
              </div>

              <div className="bg-red-50 p-4 rounded-lg">
                <h5 className="font-semibold text-red-800 mb-2">Common WSP Mistakes:</h5>
                <ul className="space-y-1 text-red-700 text-sm">
                  <li>• Incomplete skills gap analysis</li>
                  <li>• Unrealistic training budgets</li>
                  <li>• Missing employment equity data</li>
                  <li>• Late submission or incorrect format</li>
                </ul>
              </div>
            </div>
          </div>

          {/* ATR Section */}
          <div className="card p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-amber-500 text-white rounded-lg flex items-center justify-center mr-4">
                <i className="ri-file-chart-line text-xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Annual Training Report (ATR)</h3>
                <p className="text-gray-600">Due: April 30 annually</p>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Required Components:</h4>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-amber-600 text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Training activities completed during the year</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-amber-600 text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Learner achievements and certifications</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-amber-600 text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Actual expenditure on skills development</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-amber-600 text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Supporting documentation and evidence</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-line text-amber-600 text-lg mr-3 mt-1"></i>
                    <span className="text-gray-600">Impact assessment and outcomes</span>
                  </div>
                </div>
              </div>

              <div className="bg-red-50 p-4 rounded-lg">
                <h5 className="font-semibold text-red-800 mb-2">Common ATR Mistakes:</h5>
                <ul className="space-y-1 text-red-700 text-sm">
                  <li>• Insufficient supporting documentation</li>
                  <li>• Incorrect learner data reporting</li>
                  <li>• Missing training provider details</li>
                  <li>• Inadequate expenditure tracking</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-[#2D7F3E] text-white p-8 rounded-xl text-center">
          <h3 className="text-2xl font-bold mb-4">Need Help with WSP & ATR Preparation?</h3>
          <p className="text-green-100 mb-6 max-w-2xl mx-auto">
            Our experienced team can handle your entire WSP and ATR process, ensuring compliance and maximizing your grant recovery.
          </p>
          <button className="btn btn-white">
            Get WSP & ATR Support
          </button>
        </div>
      </div>
    </section>
  );
}